const actions = {
  GET_LIST_RESOURCE_SHEET: "GET_LIST_RESOURCE_SHEET",
  GET_LIST_RESOURCE_SHEET_SUCCESS: "GET_LIST_RESOURCE_SHEET_SUCCESS",
  GET_LIST_RESOURCE_SHEET_ERROR: "GET_LIST_RESOURCE_SHEET_ERROR",

  SAVE_RESOURCE_SHEET: "SAVE_RESOURCE_SHEET",
  SAVE_RESOURCE_SHEET_SUCCESS: "SAVE_RESOURCE_SHEET_SUCCESS",
  SAVE_RESOURCE_SHEET_ERROR: "SAVE_RESOURCE_SHEET_ERROR",

  APPEND_RESOURCE_SHEET_WEEK: "APPEND_RESOURCE_SHEET_WEEK",
  APPEND_RESOURCE_SHEET_WEEK_SUCCESS: "APPEND_RESOURCE_SHEET_WEEK_SUCCESS",
  APPEND_RESOURCE_SHEET_WEEK_ERROR: "APPEND_RESOURCE_SHEET_WEEK_ERROR",

  getListResourceSheet: (payload) => ({
    type: actions.GET_LIST_RESOURCE_SHEET,
    payload,
  }),

  saveResourceSheet: (payload) => ({
    type: actions.SAVE_RESOURCE_SHEET,
    payload,
  }),

  appendResourceSheetWeek: (payload) => ({
    type: actions.APPEND_RESOURCE_SHEET_WEEK,
    payload,
  }),
};

export default actions;
